const CANONICAL_STATUSES = new Set(['owned', 'interested', 'excluded', 'no_shelf']);

/** Returns true if the normalized status is owned. */
export function isOwnedStatus(status) {
  return (status || '').trim().toLowerCase() === 'owned';
}

/**
 * Resolve the ownership status label for a game from a user's collection.
 *
 * @param {Array<Object>} collection - User's collection entries.
 * @param {string|number} gameId - Game ID to look up.
 * @returns {string|false} One of 'owned', 'interested', 'excluded', 'no_shelf', or false.
 */
export function getGameOwnershipStatus(collection, gameId) {
  if (!Array.isArray(collection) || !gameId) {
    return false;
  }

  const target = String(gameId);
  const gameInCollection = collection.find(
    (g) => String(g.id) === target || String(g.game_id) === target
  );

  if (!gameInCollection) {
    return false;
  }

  const status = (gameInCollection.ownership_status || "").trim().toLowerCase();

  // Return canonical status directly; anything else (including legacy 'played')
  // falls back to the no_shelf catch-all.
  if (CANONICAL_STATUSES.has(status)) return status;
  return "no_shelf";
}

/** Returns true if the game entry has has_played set. */
export function hasPlayedStatus(collection, gameId) {
  if (!Array.isArray(collection) || !gameId) {
    return false;
  }
  const target = String(gameId);
  const gameInCollection = collection.find(
    (g) => String(g.id) === target || String(g.game_id) === target
  );
  if (!gameInCollection) return false;
  if (gameInCollection.has_played !== undefined && gameInCollection.has_played !== null) {
    return Boolean(gameInCollection.has_played);
  }
  const status = (gameInCollection.ownership_status || "").trim().toLowerCase();
  return status === "played" || status === "no_shelf";
}
